// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-TyLstd-index-main_right_content-109HG","table":"components-swbl-TyLstd-index-table-ohyUI"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/TyLstd/index.css
// module id = 2296
// module chunks = 0